import { IconsEnum } from '../../assets/icons/types';
import {
  FetchCategoriesSort,
  FetchCategoriesSortTypes
} from '../categories/categoriesTypes';
import {
  FetchProductsSortTypes,
  FetchProductsSort,
  FetchProductsFilters,
  FetchProductsElasticSearchFilters
} from './productsTypes';

import { words } from '../../locales/keys';

export const INITIAL_PRODUCTS_ELASTIC_SEARCH_FILTERS: FetchProductsElasticSearchFilters =
  {};

export const INITIAL_PRODUCTS_FILTERS: FetchProductsFilters = {};
export const INITIAL_PRODUCTS_SORT: FetchProductsSort = [
  FetchProductsSortTypes.CREATED_AT_DESC
];
export const INITIAL_PRODUCTS_LIMIT = 72;

export const INITIAL_PRODUCT_COLORS_FILTERS = {};
export const INITIAL_PRODUCT_COLORS_SORT: FetchCategoriesSort = [
  FetchCategoriesSortTypes.NAME_ASC
];
export const INITIAL_PRODUCT_COLORS_LIMIT = 1000;

export const INITIAL_PRODUCT_STYLES_FILTERS = {};
export const INITIAL_PRODUCT_STYLES_SORT: FetchCategoriesSort = [
  FetchCategoriesSortTypes.NAME_ASC
];
export const INITIAL_PRODUCT_STYLES_LIMIT = 1000;

export const INITIAL_PRODUCT_MATERIALS_FILTERS = {};
export const INITIAL_PRODUCT_MATERIALS_SORT: FetchCategoriesSort = [
  FetchCategoriesSortTypes.NAME_ASC
];
export const INITIAL_PRODUCT_MATERIALS_LIMIT = 1000;

export const INITIAL_PRODUCT_TYPES_FILTERS = {};
export const INITIAL_PRODUCT_TYPES_SORT: FetchCategoriesSort = [
  FetchCategoriesSortTypes.NAME_ASC
];
export const INITIAL_PRODUCT_TYPES_LIMIT = 1000;

export const INITIAL_PRODUCT_SEASONAL_FILTERS = {};
export const INITIAL_PRODUCT_SEASONAL_SORT: FetchCategoriesSort = [
  FetchCategoriesSortTypes.NAME_ASC
];
export const INITIAL_PRODUCT_SEASONAL_LIMIT = 1000;

export const INITIAL_PRODUCT_BRANDS_FILTERS = {};
export const INITIAL_PRODUCT_BRANDS_SORT: FetchCategoriesSort = [
  FetchCategoriesSortTypes.NAME_ASC
];
export const INITIAL_PRODUCT_BRANDS_LIMIT = 200;

export const INITIAL_PRODUCT_BRANDS_SELECTED_FILTERS = {};
export const INITIAL_PRODUCT_BRANDS_SELECTED_SORT: FetchCategoriesSort = [
  FetchCategoriesSortTypes.NAME_ASC
];
export const INITIAL_PRODUCT_BRANDS_SELECTED_LIMIT = 1000;
export const INITIAL_PRODUCT_BRANDS_SELECTED_PAGE = 1;

export const selectProductsMenuKey = 'select-products-menu-key';

export const enum ProductRenderTypes {
  CORONA = 'Corona',
  V_RAY = 'V-Ray'
}

export const ProductRenderTypeIcons = {
  [ProductRenderTypes.CORONA]: IconsEnum.CORONA_SOLID,
  [ProductRenderTypes.V_RAY]: IconsEnum.VRAY_SOLID
};

export const productsSortI18nTextTypes = {
  [FetchProductsSortTypes.CREATED_AT_DESC]: words.sortByNewest,
  [FetchProductsSortTypes.SELECTED_PRODUCTS_COUNT_DESC]: words.sortByMostUsed,
  [FetchProductsSortTypes.USERS_CHOSEN_PRODUCTS_COUNT_DESC]:
    words.sortByMostLiked,
  [FetchProductsSortTypes.SCORE_DESC]: words.sortByFeatured
};

export enum ProductsPermissions {
  READ_PRODUCTS_NAME_FILTER = 'read_products_name_filter',
  READ_PRODUCTS_EDIT_BUTTON = 'read_products_edit_button',
  READ_SELF_COMPANY_LIBRARY_EDIT_PRODUCTS_BUTTON = 'read_self_company_library_edit_products_button',
  READ_OTHER_COMPANY_LIBRARY_EDIT_PRODUCTS_BUTTON = 'read_other_company_library_edit_products_button',
  READ_PRODUCTS_GRID_DELETE_BUTTON = 'read_products_grid_delete_button',
  READ_PRODUCTS_GRID_BLOCK_BUTTON = 'read_products_grid_block_button',
  READ_PRODUCT_DOWNLOAD_SEPARATELY_BUTTON = 'read_product_download_separately_button',
  READ_SELF_COMPANY_LIBRARY_PRODUCT_DOWNLOAD_SEPARATELY_BUTTON = 'read_self_company_library_product_download_separately_button',
  READ_OTHER_COMPANY_LIBRARY_PRODUCT_DOWNLOAD_SEPARATELY_BUTTON = 'read_other_company_library_product_download_separately_button',
  READ_CLEAR_PRODUCTS_CACHE_BUTTON = 'read_clear_products_cache_button',
  READ_CLEAR_PRODUCT_CACHE_BUTTON = 'read_clear_product_cache_button',
  READ_DUPLICATE_PRODUCT_BUTTON = 'read_duplicate_product_button',
  READ_SELF_PRODUCTS_LIBRARY_INDEX_PAGE = 'read_self_products_library_index_page',
  READ_USER_PRODUCTS_LIBRARY_INDEX_PAGE = 'read_user_products_library_index_page',
  READ_PRODUCTS_INDEX_PAGE = 'read_products_index_page',
  READ_PRODUCT_SHOW_PAGE = 'read_product_show_page',
  READ_PRODUCT_CREATE_PAGE = 'read_product_create_page',
  READ_PRODUCT_EDIT_PAGE = 'read_product_edit_page',
  READ_PRODUCTS_3D_SECTION = 'read_products_3d_section',
  READ_PRODUCTS_3D_SECTION_CREATE_BUTTON = 'read_products_3d_section_create_button',
  READ_PRODUCT_PREVIEW_LINK = 'read_product_preview_link',
  READ_PRODUCT_FAVORITE_BUTTON = 'read_product_favorite_button',
  READ_PRODUCT_DOWNLOAD_BUTTON = 'read_product_download_button',
  READ_SELF_COMPANY_LIBRARY_PRODUCT_DOWNLOAD_BUTTON = 'read_self_company_library_product_download_button',
  READ_OTHER_COMPANY_LIBRARY_PRODUCT_DOWNLOAD_BUTTON = 'read_other_company_library_product_download_button',
  READ_SELF_COMPANY_LIBRARY_PRODUCT_FIND_SIMILAR_BUTTON = 'read_self_company_library_product_find_similar_button',
  READ_OTHER_COMPANY_LIBRARY_PRODUCT_FIND_SIMILAR_BUTTON = 'read_other_company_library_product_find_similar_button',
  READ_PRODUCT_PREVIEW_MODEL_BUTTON = 'read_product_preview_model_button',
  READ_PRODUCT_PREVIEW_MODEL_DOWNLOAD_BUTTON = 'read_product_preview_model_download_button',
  READ_PRODUCT_DELETE_BUTTON = 'read_product_delete_button',
  READ_PRODUCT_UPDATE_IMAGE_VERSION_BUTTON = 'read_product_update_image_version_button',
  READ_PRODUCT_AI_SEARCH_FIND_ALTERNATIVES_BUTTON = 'read_product_ai_search_find_alternatives_button',
  READ_NEW_PRODUCT_BUTTON = 'read_new_product_button',
  READ_SELF_COMPANY_NEW_PRODUCT_BUTTON = 'read_self_company_new_product_button',
  READ_OTHER_COMPANY_NEW_PRODUCT_BUTTON = 'read_other_company_new_product_button',
  READ_PRODUCTS_AI_SEARCH_MODAL_BUTTON = 'read_products_ai_search_modal_button',
  READ_PRODUCTS_AI_TEXT_SEARCH_MODAL_BUTTON = 'read_products_ai_text_search_modal_button',
  READ_PRODUCTS_AI_CLIP_SEARCH_MODAL_BUTTON = 'read_products_ai_clip_search_modal_button',
  READ_PRODUCTS_AI_CLIP_GLOBAL_SEARCH_MODAL_BUTTON = 'read_products_ai_clip_global_search_modal_button',
  READ_PRODUCTS_AI_CLIP_GLOBAL_SEARCH_FILTER_MODAL_BUTTON = 'read_products_ai_clip_global_search_filter_modal_button',
  READ_PRODUCTS_SEARCH_IN_IMAGE_MODAL_BUTTON = 'read_products_search_in_image_modal_button',
  READ_SELF_COMPANY_PRODUCTS_AI_CLIP_GLOBAL_SEARCH_FILTER_MODAL_BUTTON = 'read_self_company_products_ai_clip_global_search_filter_modal_button',
  READ_OTHER_COMPANY_PRODUCTS_AI_CLIP_GLOBAL_SEARCH_FILTER_MODAL_BUTTON = 'read_other_company_products_ai_clip_global_search_filter_modal_button',
  READ_PRODUCTS_ELASTIC_SEARCH_MODAL_BUTTON = 'read_products_elastic_search_modal_button',
  READ_PRODUCTS_ELASTIC_SEARCH_SUGGEST_INPUT = 'read_products_elastic_search_suggest_input',
  READ_PRODUCTS_ELASTIC_SEARCH_SUGGEST_LABEL = 'read_products_elastic_search_suggest_label',
  READ_PRODUCTS_ELASTIC_CATEGORIES_NAV = 'read_products_elastic_categories_nav',
  READ_PRODUCTS_ELASTIC_CUSTOM_TAGS_FILTER = 'read_products_elastic_custom_tags_filter',
  READ_PRODUCTS_SEARCH_SUGGEST_LIST = 'read_products_search_suggest_list',
  READ_PRODUCTS_SEARCH_SUGGEST_LABEL = 'read_products_search_suggest_label',
  READ_PRODUCTS_IMAGE_SCALE = 'read_products_image_scale',
  READ_PRODUCTS_TOGGLE_VIEW_BUTTON = 'read_products_toggle_view_button',
  READ_PRODUCTS_CATEGORIES_FILTER = 'read_products_categories_filter',
  READ_PRODUCTS_COLLECTIONS_FILTER = 'read_products_collections_filter',
  READ_PRODUCTS_AI_MATERIAL_TAGS_FILTER = 'read_products_ai_material_tags_filter',
  READ_PRODUCTS_AI_INTERIOR_STYLE_TAGS_FILTER = 'read_products_ai_interior_style_tags_filter',
  READ_PRODUCTS_AI_ROOM_CLASSIFICATION_TAGS_FILTER = 'read_products_ai_room_classification_tags_filter',
  READ_PRODUCTS_AI_FEATURE_TAGS_FILTER = 'read_products_ai_feature_tags_filter',
  READ_PRODUCTS_AI_MAIN_COLOR_TAGS_FILTER = 'read_products_ai_main_color_tags_filter',
  READ_PRODUCTS_CLIENTS_FILTER = 'read_product_clients_filter',
  READ_PRODUCTS_FAVORITE_CHECKBOX_FILTER = 'read_products_favorite_checkbox_filter',
  READ_PRODUCTS_COMPANY_FAVORITE_CHECKBOX_FILTER = 'read_products_company_favorite_checkbox_filter',
  READ_PRODUCTS_MY_COMPANY_FAVORITE_CHECKBOX_FILTER = 'read_products_my_company_favorite_checkbox_filter',
  READ_PRODUCTS_FAVORITE_BUTTON_FILTER = 'read_products_favorite_button_filter',
  READ_PRODUCTS_NDA_FILTER = 'read_products_nda_filter',
  READ_PRODUCTS_MY_LIBRARY_FILTER = 'read_products_my_library_filter',
  READ_PRODUCTS_BLOCKED_FILTER = 'read_products_blocked_filter',
  READ_PRODUCTS_COLORS_FILTER = 'read_products_colors_filter',
  READ_PRODUCTS_MATERIALS_FILTER = 'read_products_materials_filter',
  READ_PRODUCTS_TYPE_FILTER = 'read_products_type_filter',
  READ_PRODUCTS_RENDER_TYPE_FILTER = 'read_products_render_type_filter',
  READ_PRODUCTS_SEASONAL_FILTER = 'read_products_seasonal_filter',
  READ_PRODUCTS_TOTAL_COUNT = 'read_products_total_count',
  READ_PRODUCTS_IMAGE_TOGGLE_VIEW_BUTTON = 'read_products_image_toggle_view_button',
  READ_PRODUCTS_ELASTIC_SEARCH_META = 'read_products_elastic_search_meta',
  READ_PRODUCTS_AI_SEARCH_DETECTED_ITEM_TITLE = 'read_products_ai_search_detected_item_title',
  READ_PRODUCTS_LOAD_MORE_BUTTON_ITEMS_COUNT = 'read_products_load_more_button_items_count',
  READ_PRODUCT_COPY_LINK_BUTTON = 'read_product_copy_link_button',
  READ_PRODUCT_EDIT_BUTTON = 'read_product_edit_button',
  READ_SELF_COMPANY_EDIT_PRODUCT_BUTTON = 'read_self_company_edit_product_button',
  READ_OTHER_COMPANY_EDIT_PRODUCT_BUTTON = 'read_other_company_edit_product_button',
  READ_PRODUCT_BLOCK_BUTTON = 'read_product_block_button',
  READ_PRODUCT_INDEX_PRODUCT_CUSTOM_TAGS_BUTTON = 'read_product_index_product_custom_tags_button',
  READ_PRODUCT_SUBMIT_TO_TASK_OR_PROJECT_BUTTON = 'read_product_submit_to_task_or_project_button',
  READ_PRODUCT_RENDER_TYPES = 'read_product_render_types',
  READ_PRODUCT_RENDER_TYPES_ALWAYS_SHOW_ICON = 'read_product_render_types_always_show_icon',
  READ_PRODUCT_SKU = 'read_product_sku',
  READ_PRODUCT_USED = 'read_product_used',
  READ_PRODUCT_CLIENTS = 'read_product_clients',
  READ_PRODUCT_TEAMS = 'read_product_teams',
  READ_PRODUCT_CATEGORY = 'read_product_category',
  READ_PRODUCT_STYLE = 'read_product_style',
  READ_PRODUCT_COLLECTIONS = 'read_product_collections',
  READ_PRODUCT_MATERIALS = 'read_product_materials',
  READ_PRODUCT_COLORS = 'read_product_colors',
  READ_PRODUCT_TAGS = 'read_product_tags',
  READ_PRODUCT_STATUSES = 'read_product_statuses',
  READ_PRODUCT_MISTAKE_TYPES = 'read_product_mistake_types',
  READ_PRODUCT_FILE_VERSION_TAGS = 'read_product_file_version_tags',
  READ_PRODUCT_TYPE = 'read_product_type',
  READ_PRODUCT_SEASONAL = 'read_product_seasonal',
  READ_PRODUCT_TASK = 'read_product_task',
  READ_PRODUCT_CUSTOM_TAGS = 'read_product_custom_tags',
  READ_PRODUCT_TEAM_CUSTOM_TAGS = 'read_product_team_custom_tags',
  READ_PRODUCT_SCORE = 'read_product_score',
  READ_PRODUCT_UPLOADED = 'read_product_uploaded',
  READ_PRODUCT_UPDATED = 'read_product_updated',
  READ_PRODUCT_CREATED_BY = 'read_product_created_by',
  CHANGE_PRODUCT_NAME = 'change_product_name',
  CHANGE_PRODUCT_CATEGORY_ID = 'change_product_category_id',
  CHANGE_PRODUCT_BRAND_ID = 'change_product_brand_id',
  CHANGE_PRODUCT_STYLE_ID = 'change_product_style_id',
  CHANGE_PRODUCT_MATERIAL_IDS = 'change_product_material_ids',
  CHANGE_PRODUCT_TAG_IDS = 'change_product_tag_ids',
  CHANGE_PRODUCT_MAX_FILE_IDS = 'change_product_max_file_ids',
  CHANGE_PRODUCT_PREVIEW_MODEL_ID = 'change_product_preview_model_id',
  CHANGE_PRODUCT_IMAGE_IDS = 'change_product_image_ids',
  CHANGE_PRODUCT_DEFAULT_IMAGE = 'change_product_default_image',
  CHANGE_PRODUCT_ASSOCIATED_ASSETS = 'change_product_associated_assets',
  CHANGE_PRODUCT_ASSOCIATED_MATERIALS = 'change_product_associated_materials',
  CHANGE_PRODUCT_SKU = 'change_product_sku',
  CHANGE_PRODUCT_NDA = 'change_product_nda',
  CHANGE_PRODUCT_CLIENT_IDS = 'change_product_client_ids',
  CHANGE_PRODUCT_TEAM_IDS = 'change_product_team_ids',
  CHANGE_PRODUCT_COLLECTION_IDS = 'change_product_collection_ids',
  CHANGE_PRODUCT_FILE_VERSION_TAG_IDS = 'change_product_file_version_tag_ids',
  CHANGE_PRODUCT_COLOR_IDS = 'change_product_color_ids',
  CHANGE_PRODUCT_STATUS_IDS = 'change_product_status_ids',
  CHANGE_PRODUCT_MISTAKE_TYPE_IDS = 'change_product_mistake_type_ids',
  CHANGE_PRODUCT_RENDER_TYPE_IDS = 'change_product_render_type_ids',
  CHANGE_PRODUCT_TYPE_ID = 'change_product_type_id',
  CHANGE_PRODUCT_SEASONAL_ID = 'change_product_seasonal_id',
  CHANGE_PRODUCT_CUSTOM_TAG_IDS = 'change_product_custom_tag_ids',
  CHANGE_PRODUCT_TEAM_CUSTOM_TAG_IDS = 'change_product_team_custom_tag_ids',
  CHANGE_PRODUCT_TASK = 'change_product_task',
  READ_PRODUCT_ATTACH_BUTTON = 'read_product_attach_button',
  READ_PRODUCT_ASSOCIATED_ASSETS = 'read_product_associated_assets',
  READ_PRODUCT_ASSOCIATED_MATERIALS = 'read_product_associated_materials',
  READ_PRODUCT_FIND_SIMILAR_BUTTON = 'read_product_find_similar_button',
  READ_PRODUCT_FIND_SIMILAR_FILTER_BUTTON = 'read_product_find_similar_filter_button',
  READ_PRODUCT_SIMILAR_PRODUCTS = 'read_product_similar_products',
  READ_PRODUCT_CACHE_SIMILAR_PRODUCTS = 'read_product_cache_similar_products',
  READ_PRODUCT_CACHE_SIMILAR_PRODUCTS_WITH_SIMILAR_PRODUCT_IMAGE_FILTER = 'read_product_cache_similar_products_with_similar_product_image_filter',
  READ_PRODUCT_SHOW_MNESIA_QUERY = 'read_product_show_mnesia_query',
  READ_PRODUCT_SHOW_ES_QUERY = 'read_product_show_es_query',
  READ_PRODUCTS_INDEX_ES_QUERY = 'read_products_index_es_query',
  READ_SUGGEST_PRODUCTS_ES_QUERY = 'read_suggest_products_es_query',
  READ_PRODUCTS_AGGREGATIONS = 'read_products_aggregations',
  READ_PRODUCTS_SEARCH_WITH_TASK_NAME = 'read_products_search_with_task_name',
  READ_PRODUCT_TASK_WITH_TEAMS = 'read_product_task_with_teams',
  READ_PRODUCTS_WITH_TEAMS = 'read_products_with_teams',
  // Products grid — per-field column visibility (read) / cell editing (change)
  READ_PRODUCTS_GRID_NAME_FIELD = 'read_products_grid_name_field',
  CHANGE_PRODUCTS_GRID_NAME_FIELD = 'change_products_grid_name_field',
  READ_PRODUCTS_GRID_SKU_FIELD = 'read_products_grid_sku_field',
  CHANGE_PRODUCTS_GRID_SKU_FIELD = 'change_products_grid_sku_field',
  READ_PRODUCTS_GRID_NDA_FIELD = 'read_products_grid_nda_field',
  CHANGE_PRODUCTS_GRID_NDA_FIELD = 'change_products_grid_nda_field',
  READ_PRODUCTS_GRID_BRAND_FIELD = 'read_products_grid_brand_field',
  CHANGE_PRODUCTS_GRID_BRAND_FIELD = 'change_products_grid_brand_field',
  READ_PRODUCTS_GRID_CATEGORY_FIELD = 'read_products_grid_category_field',
  CHANGE_PRODUCTS_GRID_CATEGORY_FIELD = 'change_products_grid_category_field',
  READ_PRODUCTS_GRID_STYLE_FIELD = 'read_products_grid_style_field',
  CHANGE_PRODUCTS_GRID_STYLE_FIELD = 'change_products_grid_style_field',
  READ_PRODUCTS_GRID_TYPE_FIELD = 'read_products_grid_type_field',
  CHANGE_PRODUCTS_GRID_TYPE_FIELD = 'change_products_grid_type_field',
  READ_PRODUCTS_GRID_SEASONAL_FIELD = 'read_products_grid_seasonal_field',
  CHANGE_PRODUCTS_GRID_SEASONAL_FIELD = 'change_products_grid_seasonal_field',
  READ_PRODUCTS_GRID_COLLECTIONS_FIELD = 'read_products_grid_collections_field',
  CHANGE_PRODUCTS_GRID_COLLECTIONS_FIELD = 'change_products_grid_collections_field',
  READ_PRODUCTS_GRID_MATERIALS_FIELD = 'read_products_grid_materials_field',
  CHANGE_PRODUCTS_GRID_MATERIALS_FIELD = 'change_products_grid_materials_field',
  READ_PRODUCTS_GRID_COLORS_FIELD = 'read_products_grid_colors_field',
  CHANGE_PRODUCTS_GRID_COLORS_FIELD = 'change_products_grid_colors_field',
  READ_PRODUCTS_GRID_TAGS_FIELD = 'read_products_grid_tags_field',
  CHANGE_PRODUCTS_GRID_TAGS_FIELD = 'change_products_grid_tags_field',
  READ_PRODUCTS_GRID_CUSTOM_TAGS_FIELD = 'read_products_grid_custom_tags_field',
  CHANGE_PRODUCTS_GRID_CUSTOM_TAGS_FIELD = 'change_products_grid_custom_tags_field',
  READ_PRODUCTS_GRID_TEAM_CUSTOM_TAGS_FIELD = 'read_products_grid_team_custom_tags_field',
  CHANGE_PRODUCTS_GRID_TEAM_CUSTOM_TAGS_FIELD = 'change_products_grid_team_custom_tags_field',
  READ_PRODUCTS_GRID_STATUSES_FIELD = 'read_products_grid_statuses_field',
  CHANGE_PRODUCTS_GRID_STATUSES_FIELD = 'change_products_grid_statuses_field',
  READ_PRODUCTS_GRID_MISTAKE_TYPES_FIELD = 'read_products_grid_mistake_types_field',
  CHANGE_PRODUCTS_GRID_MISTAKE_TYPES_FIELD = 'change_products_grid_mistake_types_field',
  READ_PRODUCTS_GRID_FILE_VERSION_TAGS_FIELD = 'read_products_grid_file_version_tags_field',
  CHANGE_PRODUCTS_GRID_FILE_VERSION_TAGS_FIELD = 'change_products_grid_file_version_tags_field',
  READ_PRODUCTS_GRID_RENDER_TYPES_FIELD = 'read_products_grid_render_types_field',
  CHANGE_PRODUCTS_GRID_RENDER_TYPES_FIELD = 'change_products_grid_render_types_field',
  SAVE_PRODUCTS_GRID_STATE = 'save_products_grid_state',
  READ_PRODUCTS_GRID_FAVORITE_FIELD = 'read_products_grid_favorite_field',
  CHANGE_PRODUCTS_GRID_FAVORITE_FIELD = 'change_products_grid_favorite_field',
  READ_PRODUCTS_GRID_COMPANIES_FIELD = 'read_products_grid_companies_field',
  CHANGE_PRODUCTS_GRID_COMPANIES_FIELD = 'change_products_grid_companies_field',
  READ_PRODUCTS_GRID_CLIENTS_FIELD = 'read_products_grid_clients_field',
  CHANGE_PRODUCTS_GRID_CLIENTS_FIELD = 'change_products_grid_clients_field',
  READ_PRODUCTS_GRID_TASK_FIELD = 'read_products_grid_task_field',
  CHANGE_PRODUCTS_GRID_TASK_FIELD = 'change_products_grid_task_field',
  READ_PRODUCTS_GRID_USER_FIELD = 'read_products_grid_user_field',
  READ_PRODUCTS_GRID_MAX_FILE_FIELD = 'read_products_grid_max_file_field',
  CHANGE_PRODUCTS_GRID_MAX_FILE_FIELD = 'change_products_grid_max_file_field',
  READ_PRODUCTS_GRID_PREVIEW_MODEL_FIELD = 'read_products_grid_preview_model_field',
  CHANGE_PRODUCTS_GRID_PREVIEW_MODEL_FIELD = 'change_products_grid_preview_model_field',
  READ_PRODUCTS_GRID_IMAGES_FIELD = 'read_products_grid_images_field',
  CHANGE_PRODUCTS_GRID_IMAGES_FIELD = 'change_products_grid_images_field',
  READ_PRODUCTS_GRID_LIFESTYLES_FIELD = 'read_products_grid_lifestyles_field',
  CHANGE_PRODUCTS_GRID_LIFESTYLES_FIELD = 'change_products_grid_lifestyles_field',
  READ_PRODUCTS_GRID_ASSOCIATED_MATERIALS_FIELD = 'read_products_grid_associated_materials_field',
  CHANGE_PRODUCTS_GRID_ASSOCIATED_MATERIALS_FIELD = 'change_products_grid_associated_materials_field',
  READ_PRODUCTS_GRID_UPLOADED_FIELD = 'read_products_grid_uploaded_field',
  READ_PRODUCTS_GRID_CREATED_AT_FIELD = 'read_products_grid_created_at_field',
  READ_PRODUCTS_GRID_UPDATED_AT_FIELD = 'read_products_grid_updated_at_field',
  READ_PRODUCTS_GRID_BATCH_UPDATE_FIELDS_BUTTON = 'read_products_grid_batch_update_fields_button',
  READ_PRODUCTS_GRID_ATTACH_BUTTON = 'read_products_grid_attach_button',
  READ_PRODUCTS_GRID_DOWNLOAD_BUTTON = 'read_products_grid_download_button',
  BATCH_CHANGE_PRODUCTS_GRID_NAME_FIELD = 'batch_change_products_grid_name_field',
  BATCH_CHANGE_PRODUCTS_GRID_SKU_FIELD = 'batch_change_products_grid_sku_field',
  BATCH_CHANGE_PRODUCTS_GRID_NDA_FIELD = 'batch_change_products_grid_nda_field',
  BATCH_CHANGE_PRODUCTS_GRID_BRAND_FIELD = 'batch_change_products_grid_brand_field',
  BATCH_CHANGE_PRODUCTS_GRID_CATEGORY_FIELD = 'batch_change_products_grid_category_field',
  BATCH_CHANGE_PRODUCTS_GRID_STYLE_FIELD = 'batch_change_products_grid_style_field',
  BATCH_CHANGE_PRODUCTS_GRID_TYPE_FIELD = 'batch_change_products_grid_type_field',
  BATCH_CHANGE_PRODUCTS_GRID_SEASONAL_FIELD = 'batch_change_products_grid_seasonal_field',
  BATCH_CHANGE_PRODUCTS_GRID_COLLECTIONS_FIELD = 'batch_change_products_grid_collections_field',
  BATCH_CHANGE_PRODUCTS_GRID_MATERIALS_FIELD = 'batch_change_products_grid_materials_field',
  BATCH_CHANGE_PRODUCTS_GRID_COLORS_FIELD = 'batch_change_products_grid_colors_field',
  BATCH_CHANGE_PRODUCTS_GRID_TAGS_FIELD = 'batch_change_products_grid_tags_field',
  BATCH_CHANGE_PRODUCTS_GRID_CUSTOM_TAGS_FIELD = 'batch_change_products_grid_custom_tags_field',
  BATCH_CHANGE_PRODUCTS_GRID_TEAM_CUSTOM_TAGS_FIELD = 'batch_change_products_grid_team_custom_tags_field',
  BATCH_CHANGE_PRODUCTS_GRID_STATUSES_FIELD = 'batch_change_products_grid_statuses_field',
  BATCH_CHANGE_PRODUCTS_GRID_MISTAKE_TYPES_FIELD = 'batch_change_products_grid_mistake_types_field',
  BATCH_CHANGE_PRODUCTS_GRID_FILE_VERSION_TAGS_FIELD = 'batch_change_products_grid_file_version_tags_field',
  BATCH_CHANGE_PRODUCTS_GRID_RENDER_TYPES_FIELD = 'batch_change_products_grid_render_types_field',
  BATCH_CHANGE_PRODUCTS_GRID_COMPANIES_FIELD = 'batch_change_products_grid_companies_field',
  BATCH_CHANGE_PRODUCTS_GRID_LIFESTYLES_FIELD = 'batch_change_products_grid_lifestyles_field',
  BATCH_CHANGE_PRODUCTS_GRID_ASSOCIATED_MATERIALS_FIELD = 'batch_change_products_grid_associated_materials_field'
}

export enum ProductsCategories {
  KITCHEN = '19',
  PLANTS = '4955',
  HOME_DECOR = '21',
  EXTERIOR = '7094',
  HOME_TEXTILES = '1752',
  ARCHITECTURAL_PART = '4024',
  BATHROOM = '20',
  BEDROOMS = '18',
  CHILDRENS_ROOMS = '7533',
  COMMERCIAL_PREMISES = '8681',
  EQUIPMENT_AND_DEVICES = '1751',
  FURNITURE_FOR_STORAGE = '3',
  LIGHTING = '15',
  OFFICE_FURNITURE = '7401',
  PEOPLE_AND_ANIMALS = '6820',
  SOFAS_AND_ARMCHAIRS = '1',
  TABLES_AND_CHAIRS = '2'
}
